export default __webpack_public_path__ + "static/media/current-last-day-check-in-container.a69d0361.webp";